export default function getErrorStack(error?: Error): string | void {
  return error && error.stack ? error.stack : new Error().stack;
}
